export enum StorageKey {
  LastVisitedArticles = 'lastVisitedArticles',
  ShippingAddressId = 'shippingAddressId',
  KnowsHowToUse3DViewer = 'knowsHowToUse3DViewer',
}
